module.exports = __webpack_public_path__ + "img/05-0banner.b6e92ed5.png";